'use strict';

import template from './copy_my_data_modal.html';


var controller = function ($rootScope, $scope, settings, userModel) {
  'ngInject';
  var self = this;
  self.isSaving = false;
  self.isLoaded = false;
  self.email = false;
  self.emailVerified = false;
  self.error = false;

  settings.fetch().then(function (data) {
    if(settings.isValid('email')) {
      self.email = data.email.value;
      self.emailVerified = data.email.verified;
    }
    self.isLoaded = true;
  });

  self.copyData = function () {
    userModel.copyData().then((data)=>{
      self.done();
    },(data)=>{
      self.error = true;
    })
  };
};

export default function () {
  return {
    template: template,
    replace: true,
    scope: {
      done: '&',
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller,
  };
}



// WEBPACK FOOTER //
// ./app/src/directives/copy_my_data_modal.js